import React from "react";
import { Filter } from "react-feather";
import { Card } from "../../../shared/Card/Card";
import { PrimaryButton } from "../../../shared/Buttons/Buttons";
import "./interviewLogFilter.scss";

interface InterviewLogsSecondaryFiltersProps {
  selectedInterviewUser: string | undefined;
  setSelectedInterviewUser: (user: string | undefined) => void;
  dateFrom: Date | undefined;
  setDateFrom: (date: Date | undefined) => void;
  dateTo: Date | undefined;
  setDateTo: (date: Date | undefined) => void;
  clearAllFilters: () => void;
  users: Array<{ id: string | number; name: string; email?: string }>;
}

/**
 * User + date filters only (search lives in InterviewLogsHistorySearch).
 */
const InterviewLogsSecondaryFilters: React.FC<
  InterviewLogsSecondaryFiltersProps
> = ({
  selectedInterviewUser,
  setSelectedInterviewUser,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  clearAllFilters,
  users,
}) => {
  const formatDate = (date: Date) => date.toISOString().split("T")[0];

  return (
    <Card>
      <div className="interview-log-filter">
        <div className="filter-header">
          <div className="filter-title">
            <Filter className="filter-icon" />
            <h3>Filters</h3>
          </div>
          <PrimaryButton
            text="Clear All"
            type="button"
            onClick={clearAllFilters}
            size="sm"
          />
        </div>

        <div className="filter-grid">
          <div className="filter-field">
            <label htmlFor="ilcv-user-select" className="filter-label">
              User
              <select
                id="ilcv-user-select"
                className="filter-select"
                value={selectedInterviewUser}
                onChange={(e) => setSelectedInterviewUser(e.target.value)}
              >
                <option value="all">All Users</option>
                {users.map((user: any) => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className="filter-field">
            <label htmlFor="ilcv-date-from" className="filter-label">
              Date From
              <input
                id="ilcv-date-from"
                type="date"
                className="filter-input"
                value={dateFrom ? formatDate(dateFrom) : ""}
                onChange={(e) =>
                  setDateFrom(
                    e.target.value ? new Date(e.target.value) : undefined
                  )
                }
              />
            </label>
          </div>

          <div className="filter-field">
            <label htmlFor="ilcv-date-to" className="filter-label">
              Date To
              <input
                id="ilcv-date-to"
                type="date"
                className="filter-input"
                value={dateTo ? formatDate(dateTo) : ""}
                onChange={(e) =>
                  setDateTo(
                    e.target.value ? new Date(e.target.value) : undefined
                  )
                }
              />
            </label>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default InterviewLogsSecondaryFilters;
